<template>
    <div class="col backgroundForm">
        <div class="col col-md-10 offset-md-1">
            <h3 clas="col" align="center">Solicitud de Matriculación o Registro </h3>
            <!-- <h6 align="right">Costo Matriculacion : {{ c_cost_enrollment }}</h6>
            <h6 align="right">UFV : {{ c_ufv }} al {{ ufv_date }} <button class="btn btn-success" @click="callUfv"> <font-awesome-icon icon="sync-alt" size="lg" /> </button></h6>
            <h5 align="left">P: {{ c_type_propulsion }} A: {{ c_service }}  T: {{ c_trb }} C: {{ c_cal_cut }}</h5> -->
            <nav>
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link disabled" :class="[is_active_step_one ? 'active':'']" id="nav-init-enrollment" data-toggle="tab" href="#nav-init-enrollment" role="tab" aria-controls="nav-home" aria-selected="true">1. Datos</a>
                    <a class="nav-item nav-link disabled" :class="[is_active_step_two ? 'active':'']" id="nav-second-enrollment" data-toggle="tab" href="#nav-second-enrollment" role="tab" aria-controls="nav-detail" aria-selected="false">2. Dimensiones y Capacidades</a>
                    <a class="nav-item nav-link disabled" :class="[is_active_step_tree ? 'active':'']" id="nav-tirdh-enrollment" data-toggle="tab" href="#nav-tirdh-enrollment" role="tab" aria-controls="nav-property" aria-selected="false">3. Motor</a>
                    <a class="nav-item nav-link disabled" :class="[is_active_step_fourth ? 'active':'']" id="nav-fourth-enrollment" data-toggle="tab" href="#nav-fourth-enrollment" role="tab" aria-controls="nav-property" aria-selected="false">4. Radio/ Mat. Bélico</a>
                    <a class="nav-item nav-link disabled" :class="[is_active_step_five ? 'active':'']" id="nav-five-enrollment" data-toggle="tab" href="#nav-five-enrollment" role="tab" aria-controls="nav-property" aria-selected="false">5. Complementarios</a>
                    <a class="nav-item nav-link disabled" :class="[is_active_step_six ? 'active':'']" id="nav-six-enrollment" data-toggle="tab" href="#nav-six-enrollment" role="tab" aria-controls="nav-motor" aria-selected="false">6. Comandante</a>
                </div>
            </nav>
            

            <div class="tab-content" id="nav-tabContent">
                
                <div class="tab-pane fade" :class="[is_active_step_one ? 'show active':'']" id="nav-init-enrollment" role="tabpanel" aria-labelledby="nav-home-tab">
                    <div class="form-row">
                        <div class="form-group col col-md-6">
                            <label for="nombre_embarcacion" class="badge badge-primary">Nombre de la Embarcación</label>                    
                            <input type="text" class="form-control" v-model="name_ship" id="enrollment_boat" placeholder="Nombre Embarcacion" autocomplete="off">
                        </div>
                        
                        <div class="form-group col col-md-6">
                            <label for="bandera_embarcacion" class="badge badge-primary">Bandera de la Embarcación</label>
                            <input type="text" class="form-control" v-model="flag" name="flag" disabled placeholder="BOLIVIA" autocomplete="off">
                        </div>
                        
                        <!-- <div class="form-group col col-md-6">
                            <label for="omi" class="badge badge-primary">Numero OMI</label>
                            <input type="text" class="form-control" v-model="omi" name="omi" placeholder="OMI" autocomplete="off">
                        </div> -->

                    </div>
                    <div class="form-row">    

                        <!-- <div class="form-group col col-md-6">
                            <label for="propulsion" class="badge badge-primary">Señal de llamada</label>
                            <input type="text" class="form-control" v-model="call_sign" name="call_sign" placeholder="Señal de llamada" autocomplete="off">
                        </div> -->
                    </div>
                    <div class="form-row">
                        <div class="form-group col col-md">
                            <label for="material_head" class="badge badge-primary">Material del casco</label>
                            <select class="form-control" name="material_head" v-model="material_head">
                                <option v-for="head in material_heads" :value="head.id" :key="head.id">{{ head.detail }}</option>
                            </select>
                        </div>
                        
                        <div class="form-group col col-md">
                            <label for="material_head" class="badge badge-primary">Tipo Casco</label>
                            <input type="text" autocomplete="off" v-model="tipo_casco" class="form-control">
                        </div>

                        <div class="form-group col col-md">
                            <label for="type_navigate" class="badge badge-primary">Tipo Navegación</label>
                            <select class="form-control" name="type_navigate" v-model="type_navigate">
                                <option v-for="navigate in type_navigates" :value="navigate.id" :key="navigate.id">{{ navigate.detail }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col col-md">
                            <label for="type_ship" class="badge badge-primary">Tipo de nave</label>
                            <select class="form-control" name="type_ship" v-model="type_ship">
                                <option v-for="ship in type_ships" :value="ship.id" :key="ship.id">{{ ship.detail }}</option>
                            </select>
                        </div>
                        <div class="form-group col col-md">
                            <label for="type_ship" class="badge badge-primary">Tipo de Propulsión</label>
                            <select class="form-control" name="type_ship" v-model="d_type_propulsion">
                                <option v-for="propulsion in d_type_propulsions" :value="propulsion" :key="propulsion.id">{{ propulsion.detail }}</option>
                            </select>
                        </div>                        
                    </div>

                    <div class="form-row">
                        <div class="form-group col col-md">
                            <label for="year_construction" class="badge badge-primary">Año de construccion</label>
                            <input type="number" class="form-control" v-model="year_construction" name="flag" placeholder="Año" autocomplete="off">
                        </div>

                        <div class="form-group col col-md">
                            <label for="site_contruction" class="badge badge-primary">Lugar construccion</label>
                            <input type="text" class="form-control" v-model="site_construction" name="call_sign" placeholder="Lugar de construccion" autocomplete="off">
                        </div>

                        <div class="form-group col col-md">
                            <label for="cost_construction" class="badge badge-primary">Costo de construccion Bs.</label>
                            <input type="number" class="form-control" v-model="cost_construction" name="flag" placeholder="Costo" autocomplete="off">
                        </div>

                        <div class="form-group col col-md">
                            <label for="empresa_construccion" class="badge badge-primary">Empresa</label>
                            <input type="text" class="form-control" v-model="empresa_construccion" name="flag" placeholder="Empresa Construccion" autocomplete="off">
                        </div>
                    </div>
                    
                    <div class="form-row">
                        <div class="form-group col col-md">
                            <label for="lugar_botadura" class="badge badge-primary">Lugar y Fecha de Botadura</label>
                            <input type="text" class="form-control" v-model="lugar_botadura" name="flag" placeholder="Lugar Botadura" autocomplete="off">
                        </div>
                        <div class="form-group col col-md">
                            <label for="operabilidad_nave" class="badge badge-primary">Estado Operabilidad Embarcacion</label>
                            <select class="form-control" name="operabilidad_nave" id="operabilidad_nave" v-model="operabilidad">
                                <option value="O">Operable</option>
                                <option value="I">Inoperable</option>
                            </select>
                        </div>

                        <div class="form-group col col-md">
                            <label for="qth_nave" class="badge badge-primary">QTH</label>
                            <input type="text" class="form-control" v-model="qth_embarcacion" name="flag" placeholder="CP. MY. xxxxxx" autocomplete="off">
                        </div>
                    </div>
                    
                    <h5>Actividad Empeñada</h5>
                    <hr> 
                    <div class="form-row">
                        <div class="form-group col col-md">
                            <label for="actividad_principal" class="badge badge-primary">Actividad Principal</label>
                            <input type="text" class="form-control" v-model="actividad_principal" name="calado" placeholder="Actividad Principal" autocomplete="off">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col col-md">
                            <label for="actividad_secundaria" class="badge badge-primary">Actividad Secundaria</label>
                            <input type="text" class="form-control" v-model="actividad_secundaria" name="calado" placeholder="Actividad Secundaria" autocomplete="off">
                        </div>
                    </div>

                    <button class="btn btn-outline-warning col col-md-4 offset-md-4" @click="fNext"><font-awesome-icon icon="chevron-circle-right" size="lg" /></button>
                </div>
                <!-- end first tab traffic -->

                <div class="tab-pane fade" :class="[is_active_step_two ? 'show active':'']" id="nav-second-enrollment" role="tabpanel" aria-labelledby="nav-profile-tab">
                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="trb" class="badge badge-primary">TRB</label>
                            <input type="number" name="trb" class="form-control" placeholder="TRB" v-model="trb" autocomplete="off">
                        </div>
                        <div class="form-group col-12 col-md-6">
                            <label for="trn" class="badge badge-primary">TRN</label>
                            <input type="number" name="trn" class="form-control" placeholder="TRN" v-model="trn" autocomplete="off">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col col-md">
                            <label for="eslora" class="badge badge-primary">Eslora</label>
                            <input type="number" class="form-control" v-model="eslora" name="eslora" placeholder="Eslora" autocomplete="off">
                        </div>
                        <div class="form-group col col-md">
                            <label for="manga" class="badge badge-primary">Manga</label>
                            <input type="number" class="form-control" v-model="manga" name="manga" placeholder="Manga" autocomplete="off">
                        </div>
                        <div class="form-group col col-md">
                            <label for="puntal" class="badge badge-primary">Puntal</label>
                            <input type="number" class="form-control" v-model="puntal" name="puntal" placeholder="Puntal" autocomplete="off">
                        </div>
                        <div class="form-group col col-md">
                            <label for="eslora" class="badge badge-primary">Calado Min.</label>
                            <input type="number" class="form-control" v-model="calado" name="calado" placeholder="Calado Min" autocomplete="off">
                        </div>
                        <div class="form-group col col-md">
                            <label for="eslora" class="badge badge-primary">Calado Max.</label>
                            <input type="number" class="form-control" v-model="calado_max" name="calado" placeholder="Calado Max" autocomplete="off">
                        </div>
                    </div>                      

                    <h5>Velocidad</h5>
                    <hr>
                    <div class="form-row">
                        <div class="form-group col col-md">
                            <label for="vel_crucero" class="badge badge-primary">Crucero</label>
                            <input type="text" class="form-control" v-model="vel_crucero" name="calado" placeholder="Velocidad Crucero" autocomplete="off">
                        </div>
                        <div class="form-group col col-md">
                            <label for="vel_maxima" class="badge badge-primary">Máxima</label>
                            <input type="text" class="form-control" v-model="vel_maxima" name="calado" placeholder="velocidad Maxima" autocomplete="off">
                        </div>
                        <div class="form-group col col-md">
                            <label for="comb_hora" class="badge badge-primary">Comb/Hora</label>
                            <input type="text" class="form-control" v-model="comb_hora" name="calado" placeholder="Combustible / Hora" autocomplete="off">
                        </div>
                        <div class="form-group col col-md">
                            <label for="autonomia" class="badge badge-primary">Autonomia</label>
                            <input type="text" class="form-control" v-model="autonomia" name="calado" placeholder="Autonomia" autocomplete="off">
                        </div>
                    </div>

                    <h5>Francobordo</h5>
                    <hr>
                    <div class="form-row">
                        <div class="form-group col col-md">
                            <label for="fb_carga" class="badge badge-primary">A plena Carga</label>
                            <input type="text" class="form-control" v-model="fb_p_carga" name="calado" placeholder="A plena Carga" autocomplete="off">
                        </div>
                        <div class="form-group col col-md">
                            <label for="fb_s_carga" class="badge badge-primary">Sin Carga</label>
                            <input type="text" class="form-control" v-model="fb_s_carga" name="calado" placeholder="Sin Carga" autocomplete="off">
                        </div>
                    </div>

                    <button class="btn btn-outline-danger col col-md-4 offset-md-2" @click="fBack">
                        <font-awesome-icon icon="chevron-circle-left" size="lg" />
                    </button>
                    <button class="btn btn-outline-warning col col-md-4" @click="fNext">
                        <font-awesome-icon icon="chevron-circle-right" size="lg" />
                    </button>
                </div>
                <!-- end second tab -->

                <div class="tab-pane fade" :class="[is_active_step_tree ? 'show active':'']" id="nav-tirdh-enrollment" role="tabpanel" aria-labelledby="nav-home-tab">
                    
                    <transition name="fade" mode="out-in">
                        <div class="form-row" v-if="cQuestionEngine">
                            <span class="col-12">¿Desea agregar caracteristicas de motor a la nave? <br>Caso contrario omita este mensaje y pase al siguiente paso  </span>                        
                            <button class="btn btn-outline-success btn-sm col-6 col-md-2 offset-md-4" value="si" @click="mAddEngine">AGREGAR</button>
                            <!-- <button class="btn btn-outline-danger btn-sm col-6 col-md-2" value="no" @click="mAddEngine">NO</button> -->
                            
                        </div>
                        
                    </transition>

                    <transition name="fade" mode="out-in">
                    <div v-if="engine.exists">
                        <div class="form-row">
                            <button type="button" class="btn btn-outline-warning col-12 col-md-1 offset-md-10" @click="mAddEngine" value="no"><font-awesome-icon icon="redo-alt" /></button>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 col-md">
                                <label for="brand_engine" class="badge badge-primary">Marca Motor</label>
                                <input type="text" class="form-control" v-model="engine.trademark" name="flag" placeholder="Marca Motor" autocomplete="off">
                            </div>

                            <div class="form-group col-12 col-md">
                                <label for="model_engine" class="badge badge-primary">Modelo Motor</label>
                                <input type="text" class="form-control" v-model="engine.model" name="model_engine" placeholder="Modelo Motor" autocomplete="off">
                            </div>                        
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md">
                                <label for="rpm_engine" class="badge badge-primary">RPM</label>
                                <input type="number" class="form-control" v-model="engine.rpm" name="flag" placeholder="Hp por RPM" autocomplete="off">
                            </div>

                            <div class="form-group col-12 col-md">
                                <label for="serie_engine" class="badge badge-primary">Serie</label>
                                <input type="text" class="form-control" v-model="engine.serie" name="model_engine" placeholder="Serie Motor" autocomplete="off">
                            </div>                    
                        </div>
                        
                        <div class="form-row">
                            <div class="form-group col-12 col-md">
                                <label for="combustible_construction" class="badge badge-primary">Combustible</label>
                                <select class="form-control" name="combustible_construction" v-model="engine.gasoline">
                                    <option v-for="gas in type_gasolines" :value="gas.id" :key="gas.id">{{ gas.detail }}</option>
                                </select>
                            </div>

                            <div class="form-group col-12 col-md">
                                <label for="engine_autonomia" class="badge badge-primary">Autonomia</label>
                                <input type="text" class="form-control" v-model="engine.autonomia" name="model_engine" placeholder="Autonomia Motor" autocomplete="off">
                            </div>

                            <div class="form-group col-12 col-md">
                                <label for="engine_velocity" class="badge badge-primary">Potencia</label>
                                <input type="number" class="form-control" v-model="engine.velocity_max" name="engine_velocity" placeholder="40 HP ....." autocomplete="off">
                            </div>

                            <div class="form-group col-12 col-md">
                                <label for="engine_velocity" class="badge badge-primary">Tipo Cola</label>
                                <input type="text" class="form-control" v-model="engine.tipo_cola" name="tipo_cola" placeholder="Estandar" autocomplete="off">
                            </div>
                            <div class="form-group col-12 col-md">
                                <label for="cilindros" class="badge badge-primary">No. Cilindros</label>
                                <input type="number" min="0" class="form-control" v-model="engine.n_cilindros" name="model_engine" placeholder="Serie Motor" autocomplete="off">
                            </div>
                        </div>
                        
                        <div class="form-row">    
                            <div class="form-group col-12 col-md">
                                <label for="serie_engine" class="badge badge-primary">Tipo Mezcla</label>
                                <input type="text" min="0" class="form-control" v-model="engine.t_mezcla" name="model_engine" placeholder="Serie Motor" autocomplete="off">
                            </div>
                            <div class="form-group col-12 col-md">
                                <label for="capacidad_tanque" class="badge badge-primary">Capacidad Tanque</label>
                                <input type="text" min="0" class="form-control" v-model="engine.cap_tanque" name="model_engine" placeholder="Capacidad Tanque" autocomplete="off">
                            </div>
                            <div class="form-group col-12 col-md">
                                <label for="serie_engine" class="badge badge-primary">Industria</label>
                                <input type="text" min="0" class="form-control" v-model="engine.industria" name="model_engine" placeholder="Japonesa" autocomplete="off">
                            </div>
                            <div class="form-group col-12 col-md">
                                <label for="serie_engine" class="badge badge-primary">Operabilidad</label>
                                <select for="operabilidad_motor" class="form-control" v-model="engine.operabilidad_motor">
                                    <option value="O">Operable</option>
                                    <option value="I">Inoperable</option>
                                </select>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md">
                                <label for="serie_engine" class="badge badge-primary">QTH Motor</label>
                                <input type="text" min="0" class="form-control" v-model="engine.qth_motor" name="model_engine" placeholder="Ubicacion del Motor" autocomplete="off">
                            </div>
                        </div>
                    </div>
                    </transition>
                    <br>
                    <button class="btn btn-outline-danger col col-md-4 offset-md-2" @click="fBack">
                        <font-awesome-icon icon="chevron-circle-left" size="lg" />
                    </button>
                    <button class="btn btn-outline-warning col col-md-4" @click="fNext">
                        <font-awesome-icon icon="chevron-circle-right" size="lg" />
                    </button>
                </div>


                <div class="tab-pane fade" :class="[is_active_step_fourth ? 'show active':'']" id="nav-fourth-enrollment" role="tabpanel" aria-labelledby="nav-home-tab">
                    
                    <h5>Comunicación</h5>
                    <hr>
                    <div class="form-row">                        
                        <div class="form-group col-12 col-md">
                            <label for="cant_radios" class="badge badge-primary">Cantidad Radios</label>
                            <input type="number" min="0" class="form-control" v-model="cant_radios" name="flag" placeholder="Cantidad Radios" autocomplete="off">
                        </div>
                        <div class="form-group col-12 col-md">
                            <label for="cant_baterias" class="badge badge-primary">Cantidad Baterias</label>
                            <input type="number" min="0" class="form-control" v-model="cant_baterias" name="flag" placeholder="Cantidad Baterias" autocomplete="off">
                        </div>
                        <div class="form-group col-12 col-md">
                            <label for="frecuencias" class="badge badge-primary">Frecuencias</label>
                            <input type="text" class="form-control" v-model="frecuencias" name="flag" placeholder="Frecuencias" autocomplete="off">
                        </div>
                    </div>

                    <div class="form-row">                        
                        <div class="form-group col-12 col-md">
                            <label for="cant_radios" class="badge badge-primary">Marca</label>
                            <input type="text"  class="form-control" v-model="marca_radio" name="flag" placeholder="Marca Radio(s)" autocomplete="off">
                        </div>
                        <div class="form-group col-12 col-md">
                            <label for="cant_baterias" class="badge badge-primary">Modelo Radio(s)</label>
                            <input type="text"  class="form-control" v-model="modelo_radio" name="flag" placeholder="Modelo Radio(s)" autocomplete="off">
                        </div>
                    </div>

                    <h5>Material Bélico</h5>
                    <hr>

                    <div class="table-responsive">
                        <table class="table">
                            <thead class="table-dark">
                                <tr>
                                    <th>ARMAMENTO</th>
                                    <th>CANTIDAD</th>
                                    <th>MODELO</th>
                                    <th>CALIBRE</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Ametralladoras</td>
                                    <td><input type="number" min="0" class="form-control" v-model="ametralladoras.cantidad" name="model_engine" placeholder="Serie Motor" autocomplete="off"></td>
                                    <td><input type="text" min="0" class="form-control" v-model="ametralladoras.modelo" name="model_engine" placeholder="Serie Motor" autocomplete="off"></td>
                                    <td><input type="text" min="0" class="form-control" v-model="ametralladoras.calibre" name="model_engine" placeholder="Serie Motor" autocomplete="off"></td>
                                </tr>
                                <tr>
                                    <td>Fusiles</td>
                                    <td><input type="number" min="0" class="form-control" v-model="fusiles.cantidad" name="model_engine" placeholder="Serie Motor" autocomplete="off"></td>
                                    <td><input type="text" min="0" class="form-control" v-model="fusiles.modelo" name="model_engine" placeholder="Serie Motor" autocomplete="off"></td>
                                    <td><input type="text" min="0" class="form-control" v-model="fusiles.calibre" name="model_engine" placeholder="Serie Motor" autocomplete="off"></td>
                                </tr>
                            </tbody>
                        </table>
                        
                    </div>

                    <h5>Otros datos Embarcación</h5>
                    
                    <div class="form-row">
                        <div class="form-group col col-md">
                            <label for="actividad_secundaria" class="badge badge-primary">Super Estructura</label>
                            <input type="text" class="form-control" v-model="superesctructura" name="calado" placeholder="Super Estructura" autocomplete="off">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col col-md">
                            <label for="actividad_secundaria" class="badge badge-primary">Dispositivo Control Averias</label>
                            <input type="text" class="form-control" v-model="dispositivo_averias" name="calado" placeholder="Super Estructura" autocomplete="off">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col col-md">
                            <label for="actividad_secundaria" class="badge badge-primary">Salvataje</label>
                            <input type="text" class="form-control" v-model="salvataje" name="calado" placeholder="Salvataje" autocomplete="off">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col col-md">
                            <label for="actividad_secundaria" class="badge badge-primary">Tiempo Vida Embarcación</label>
                            <input type="text" class="form-control" v-model="tiempo_vida_nave" name="calado" placeholder="Tiempo vida Nave" autocomplete="off">
                        </div>
                    </div>

                <br>
                <button class="btn btn-outline-danger col col-md-4 offset-md-2" @click="fBack">
                    <font-awesome-icon icon="chevron-circle-left" size="lg" />
                </button>
                <button class="btn btn-outline-warning col col-md-4" @click="fNext">
                    <font-awesome-icon icon="chevron-circle-right" size="lg" />
                </button>
                </div>


                <div class="tab-pane fade" :class="[is_active_step_five ? 'show active':'']" id="nav-five-enrollment" role="tabpanel" aria-labelledby="nav-home-tab">
                    
                        <h5>Maquinas / Equipo</h5>
                        <hr>

                        <div class="table-responsive">
                            <table class="table">
                                <thead class="table-dark">
                                    <tr>
                                        <th>MAQUINA/EQUIPO</th>
                                        <th>CANTIDAD</th>
                                        <th>MARCA</th>
                                        <th>OBSERVACIONES</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Bomba de Achique</td>
                                        <td><input type="number" min="0" class="form-control" v-model="b_achique.cantidad" name="model_b_achique" placeholder="Cantidad" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="b_achique.marca" name="model_b_achique" placeholder="Marca" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="b_achique.observaciones" name="model_b_achique" placeholder="Observaciones" autocomplete="off"></td>
                                    </tr>
                                    <tr>
                                        <td>Bomba de Agua</td>
                                        <td><input type="number" min="0" class="form-control" v-model="b_agua.cantidad" name="model_b_agua" placeholder="Cantidad" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="b_agua.marca" name="model_b_agua" placeholder="Marca" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="b_agua.observaciones" name="model_b_agua" placeholder="Observaciones" autocomplete="off"></td>
                                    </tr>
                                    <tr>
                                        <td>Tanque Flotación</td>
                                        <td><input type="number" min="0" class="form-control" v-model="tanque_flotacion.cantidad" name="model_tanque_flotacion" placeholder="Cantidad" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="tanque_flotacion.marca" name="model_tanque_flotacion" placeholder="Marca" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="tanque_flotacion.observaciones" name="model_tanque_flotacion" placeholder="Observaciones" autocomplete="off"></td>
                                    </tr>
                                    <tr>
                                        <td>Ecosonda</td>
                                        <td><input type="number" min="0" class="form-control" v-model="ecosonda.cantidad" name="model_ecosonda" placeholder="Cantidad" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="ecosonda.marca" name="model_ecosonda" placeholder="Marca" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="ecosonda.observaciones" name="model_ecosonda" placeholder="Observaciones" autocomplete="off"></td>
                                    </tr>
                                    <tr>
                                        <td>GPS</td>
                                        <td><input type="number" min="0" class="form-control" v-model="gps.cantidad" name="model_gps" placeholder="Cantidad" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="gps.marca" name="model_gps" placeholder="Marca" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="gps.observaciones" name="model_gps" placeholder="Observaciones" autocomplete="off"></td>
                                    </tr>
                                    <tr>
                                        <td>Rosa Náutica</td>
                                        <td><input type="number" min="0" class="form-control" v-model="rosa_nautica.cantidad" name="model_rosa_nautica" placeholder="Cantidad" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="rosa_nautica.marca" name="model_rosa_nautica" placeholder="Marca" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="rosa_nautica.observaciones" name="model_rosa_nautica" placeholder="Observaciones" autocomplete="off"></td>
                                    </tr>
                                    <tr>
                                        <td>Luces de Navegación</td>
                                        <td><input type="number" min="0" class="form-control" v-model="luces_navegacion.cantidad" name="model_luces_navegacion" placeholder="Cantidad" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="luces_navegacion.marca" name="model_luces_navegacion" placeholder="Marca" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="luces_navegacion.observaciones" name="model_luces_navegacion" placeholder="Observaciones" autocomplete="off"></td>
                                    </tr>
                                    <tr>
                                        <td>Girocompás</td>
                                        <td><input type="number" min="0" class="form-control" v-model="giro_compas.cantidad" name="model_giro_compas" placeholder="Cantidad" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="giro_compas.marca" name="model_giro_compas" placeholder="Marca" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="giro_compas.observaciones" name="model_giro_compas" placeholder="Observaciones" autocomplete="off"></td>
                                    </tr>
                                    <tr>
                                        <td>Pluma/Pescante</td>
                                        <td><input type="number" min="0" class="form-control" v-model="pluma_pescante.cantidad" name="model_pluma_pescante" placeholder="Cantidad" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="pluma_pescante.marca" name="model_pluma_pescante" placeholder="Marca" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="pluma_pescante.observaciones" name="model_pluma_pescante" placeholder="Observaciones" autocomplete="off"></td>
                                    </tr>
                                    <tr>
                                        <td>Base de remolque</td>
                                        <td><input type="number" min="0" class="form-control" v-model="base_remolque.cantidad" name="model_base_remolque" placeholder="Cantidad" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="base_remolque.marca" name="model_base_remolque" placeholder="Marca" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="base_remolque.observaciones" name="model_base_remolque" placeholder="Observaciones" autocomplete="off"></td>
                                    </tr>
                                    <tr>
                                        <td>Radar</td>
                                        <td><input type="number" min="0" class="form-control" v-model="radar.cantidad" name="model_radar" placeholder="Cantidad" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="radar.marca" name="model_radar" placeholder="Marca" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="radar.observaciones" name="model_radar" placeholder="Observaciones" autocomplete="off"></td>
                                    </tr>
                                    <tr>
                                        <td>Chaleco Salvavidas</td>
                                        <td><input type="number" min="0" class="form-control" v-model="chaleco_salvavidas.cantidad" name="model_chaleco_salvavidas" placeholder="Cantidad" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="chaleco_salvavidas.marca" name="model_chaleco_salvavidas" placeholder="Marca" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="chaleco_salvavidas.observaciones" name="model_chaleco_salvavidas" placeholder="Observaciones" autocomplete="off"></td>
                                    </tr>
                                    <tr>
                                        <td>Guindolas</td>
                                        <td><input type="number" min="0" class="form-control" v-model="guindolas.cantidad" name="model_guindolas" placeholder="Cantidad" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="guindolas.marca" name="model_guindolas" placeholder="Marca" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="guindolas.observaciones" name="model_guindolas" placeholder="Observaciones" autocomplete="off"></td>
                                    </tr>
                                    <tr>
                                        <td>Botiquin PAUX.</td>
                                        <td><input type="number" min="0" class="form-control" v-model="botiquin_paux.cantidad" name="model_botiquin_paux" placeholder="Cantidad" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="botiquin_paux.marca" name="model_botiquin_paux" placeholder="Marca" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="botiquin_paux.observaciones" name="model_botiquin_paux" placeholder="Observaciones" autocomplete="off"></td>
                                    </tr>
                                    <tr>
                                        <td>Extintor</td>
                                        <td><input type="number" min="0" class="form-control" v-model="extintor.cantidad" name="model_extintor" placeholder="Cantidad" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="extintor.marca" name="model_extintor" placeholder="Marca" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="extintor.observaciones" name="model_extintor" placeholder="Observaciones" autocomplete="off"></td>
                                    </tr>
                                    <tr>
                                        <td>Cabos</td>
                                        <td><input type="number" min="0" class="form-control" v-model="cabos.cantidad" name="model_cabos" placeholder="Cantidad" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="cabos.marca" name="model_cabos" placeholder="Marca" autocomplete="off"></td>
                                        <td><input type="text" min="0" class="form-control" v-model="cabos.observaciones" name="model_cabos" placeholder="Observaciones" autocomplete="off"></td>
                                    </tr>
                                </tbody>
                            </table>
                            
                        </div>                                     

                    <br>
                    <button class="btn btn-outline-danger col col-md-4 offset-md-2" @click="fBack">
                        <font-awesome-icon icon="chevron-circle-left" size="lg" />
                    </button>
                    <button class="btn btn-outline-warning col col-md-4" @click="fNext">
                        <font-awesome-icon icon="chevron-circle-right" size="lg" />
                    </button>
                </div>
                <!-- end trirdh tab -->
                <div class="tab-pane fade" :class="[is_active_step_six ? 'show active':'']" id="nav-six-enrollment" role="tabpanel" aria-labelledby="nav-home-tab">
                    <br>
                    <div class="form-row">
                        <div class="form-group col-12 col-md-3">
                            <label for="type_identification" class="badge badge-secondary">Busqueda Comandante UUSS</label>
                        </div>
                        <div class="form-group col-12 col-md-7">
                            <!-- <input type="text" name="search_property" id="" class="form-control form-control-sm" placeholder="Propietario"> -->

                            <vue-bootstrap-typeahead                            
                                        v-model="query_owner"
                                        :data="owners_enrollment"
                                        size="sm"
                                        :serializer="item => (item.grade +' '+item.complete+' - '+item.identification)"
                                        @hit="mSelectedOwner"
                                        :placeholder="searchOwner"
                                        :max-matches="maxResult"                                     
                            />
                        </div>
                        
                        <button type="button" class="btn btn-warning btn-sm col-12 col-md-1" @click="mResetSelectOwner" value="no"><font-awesome-icon icon="redo-alt" /> </button>
                        
                        <div class="row" v-if="owner.id!==0">
                            <label for="staticEmail" class="col-12 col-md col-form-label">Comandante Unidad Superficie :</label>
                            <div class="col-12 col-md-10">
                                <input type="text" readonly class="form-control-plaintext" id="staticEmail" :value="owner.grade+' '+owner.complete">
                            </div>
                        </div>
                        

                        
                    </div>

                    
                    <br>
                    <button class="btn btn-outline-danger col col-md-4 offset-md-2" @click="fBack">
                        <font-awesome-icon icon="chevron-circle-left" size="lg" />
                    </button>
                    <button class="btn btn-outline-primary col col-md-4" @click="mValidateSend">Solicitar <font-awesome-icon icon="save" size="lg" /></button>    
                </div>
            </div>
            
        </div>
        <modal-loading :id-modal="modal_progress" :title="'Solicitando'" :status-send="send_dispatch" ></modal-loading>
        <modal-report :id-modal-report="modal_report" :title="modal_rep_title" :content="modal_rep_content" :url-r="url_report" :id-report="id_reporte" ></modal-report>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');
import modalLoading from '../modal/modalLoading';
import modalReport from '../modal/modalReport';


export default {
    name:'enrollment',
    data(){
        return{
            autImport:'N',
            maxResult:50,
            searchOwner:'Busqueda Nombre',
            query_owner:null,
            owners_enrollment:[],
            is_active_step_one:true,
            is_active_step_two:false,
            is_active_step_tree:false,
            is_active_step_fourth:false,
            is_active_step_five:false,
            is_active_step_six:false,
            name_ship:null,
            omi:null,
            flag:'BOLIVIA',
            call_sign:null,
            material_head:null,
            type_ship:null,
            material_heads:[],
            type_ships:[],
            eslora:null,
            manga:null,
            puntal:null,
            calado:null,
            year_construction:null,
            site_construction:null,
            cost_construction:null,
            type_service:{
                id:null,
                detail:null,
                factor:null
            },
            type_services:[],
            type_navigate:null,
            type_navigates:[],
            d_type_propulsions:[],
            d_type_propulsion:{
                id:null,
                detail:null,
                factor:null
            },
            d_type_activity_ship:null,
            d_types_activity_ship:[],
            type_gasolines:[],
            engine:{
                exists:false,
                trademark:null,
                model:null,
                rpm:null,
                serie:null,
                gasoline:null,
                autonomia:null,
                velocity_max:null,
                tipo_cola:'',
                n_cilindros:'',
                t_mezcla:'',
                cap_tanque:'',
                industria:'',
                qth_motor:'',
                operabilidad_motor:0,
            },
            owner:{
                id:0,
                identification:null,
                complete:null,
                grade:null
            },
            d_owner_disabled:false,
            types_identification:[],
            citys:[],
            countrys:[],
            trn:null,
            trb:null,
            modal_progress:'sendEnrollment',
            modal_report:'requestEnrollment',
            modal_rep_title:'Solicitud de Matriculación',
            modal_rep_content:'',
            url_report:'pdfRequestEnrollment',
            send_dispatch:true,
            id_reporte:0,
            d_question_engine:true,
            d_disabled_partner:false,
            date_ufv:null,
            ufv_date:null,
            tipo_casco:'',
            empresa_construccion:'',
            lugar_botadura:'',
            operabilidad:0,
            qth_embarcacion:'',
            calado_max:0,
            vel_crucero:'',
            vel_maxima:'',
            comb_hora:'',
            autonomia:'',
            fb_p_carga:'',
            fb_s_carga:'',
            cant_radios:0,
            cant_baterias:0,
            frecuencias:'',
            marca_radio:'',
            modelo_radio:'',
            actividad_principal:'',
            actividad_secundaria:'',
            ametralladoras:{
                cantidad:0,
                modelo:'',
                calibre:''
            },
            fusiles:{
                cantidad:0,
                modelo:'',
                calibre:''
            },
            superestructura:'',
            dispositivo_averias:'',
            salvataje:'',
            tiempo_vida_nave:'',
            b_achique:{
                cantidad:0,
                marca:'',
                observaciones:''
            },
            b_agua:{
                cantidad:0,
                marca:'',
                observaciones:''
            },
            tanque_flotacion:{
                cantidad:0,
                marca:'',
                observaciones:''
            },
            ecosonda:{
                cantidad:0,
                marca:'',
                observaciones:''
            },
            gps:{
                cantidad:0,
                marca:'',
                observaciones:''
            },
            rosa_nautica:{
                cantidad:0,
                marca:'',
                observaciones:''
            },
            luces_navegacion:{
                cantidad:0,
                marca:'',
                observaciones:''
            },
            giro_compas:{
                cantidad:0,
                marca:'',
                observaciones:''
            },
            pluma_pescante:{
                cantidad:0,
                marca:'',
                observaciones:''
            },
            base_remolque:{
                cantidad:0,
                marca:'',
                observaciones:''
            },
            radar:{
                cantidad:0,
                marca:'',
                observaciones:''
            },
            chaleco_salvavidas:{
                cantidad:0,
                marca:'',
                observaciones:''
            },
            guindolas:{
                cantidad:0,
                marca:'',
                observaciones:''
            },
            botiquin_paux:{
                cantidad:0,
                marca:'',
                observaciones:''
            },
            extintor:{
                cantidad:0,
                marca:'',
                observaciones:''
            },
            cabos:{
                cantidad:0,
                marca:'',
                observaciones:''
            },
        }
    },
    mounted(){
        this.callHeads(),
        this.callTypeShip(),
        this.callTypeNavigate(),
        this.mCallPropulsion(),
        this.mCallActivitiesShip(),
        this.mCallGasolines(),
        this.mCallIdentifications(),
        this.mCallCitys(),
        this.mCallCountrys(),
        this.callUfv()
    },
    methods:{
        mEditImport(t){
            let aux_imp=0;
            switch(t){
                case 'R':
                    console.log(`restamos el importe ${this.type_service.factor}`);
                    aux_imp=parseFloat(this.type_service.factor)-0.2;
                    if(aux_imp>0){
                        this.type_service.factor=aux_imp;
                        // this.calculateForm();
                    }
                    break;
                
                case 'I':
                    console.log(`incrementamos el importe ${this.type_service.factor}`);
                    aux_imp=parseFloat(this.type_service.factor)+0.2;
                    if(aux_imp>0){
                        this.type_service.factor=aux_imp;
                        // this.calculateForm();
                    }
                    break;
            }
        },
        mSelectedOwner(data){
            // console.log(data);
            this.owner.id=data.id;
            this.owner.grade=data.grade;
            this.owner.complete=data.complete;
            this.owner.identification=data.identification;
        },
        mResetSelectOwner(){
            this.owner.id=0;
            this.owner.type_identification=null;
            this.owner.number_identification=null;
            this.owner.site_expedition=null;
            this.owner.name=null;
            this.owner.direction=null;
            this.owner.mobile=null;
            this.owner.phone=null;
            this.owner.partner=null;
            this.owner.nationality=null;
            this.d_owner_disabled=false;
            this.d_disabled_partner=false;
        },
        mAddEngine(event){
            switch(event.target.value){
                case 'no':
                    this.d_question_engine=true;
                    this.engine.exists=false;                    
                break;

                case 'si':
                    this.d_question_engine=false;
                    this.engine.exists=true;
                break;
            }
        },
        mProgressModal(){
            $('#'+this.modal_progress).modal('show');
        },
        mCloseProgressModal(){
            $('#'+this.modal_progress).modal('hide');
        },
        mModalReportShow(){
            $('#'+this.modal_report).modal('show');
        },
        mCallCountrys(){
            // axios.get(`globals/country`)
            axios.get(`globals/country?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.countrys=res.data
            })
        },
        mCallCitys(){
            // axios.get(`globals/citys`)
            axios.get(`globals/citys?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.citys=res.data
            })
        },
        mCallIdentifications(){
            // axios.get(`globals/ident`)
            axios.get(`globals/ident?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.types_identification=res.data
            })
        },
        mCallGasolines(){
            // axios.get(`globals/gasoline`)
            axios.get(`globals/gasoline?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.type_gasolines=res.data
            })
        },
        mCallPropulsion(){
            // axios.get(`submenus/4`)
            axios.get(`submenus/4?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.d_type_propulsions=res.data
            })
        },
        callHeads(){
            this.autImport=Vue.auth.getAutImp();
            // axios.get(`globals/materialhead`)
            axios.get(`globals/materialhead?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.material_heads=res.data
            })
        },
        callTypeShip(){
            // axios.get(`globals/ships`)
            axios.get(`globals/ships?api_token=${Vue.auth.getToken()}`)
            .then(res => {
                
                this.type_ships=res.data
            })
        },
        mCallActivitiesShip(){
            // axios.get(`ships/servicionave`)
            axios.get(`ships/servicionave?api_token=${Vue.auth.getToken()}`)
            .then(res => {
                this.d_types_activity_ship=res.data;
            })
        },
        callService(){
            this.type_services=[];
            // axios.get(`submenus/${this.d_type_activity_ship}`)
            axios.get(`submenus/${this.d_type_activity_ship}?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.type_services=res.data
            })
        },
        callTypeNavigate(){
            // axios.get(`globals/navigates`)
            axios.get(`globals/navigates?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.type_navigates=res.data
            })
        },
        mSendEnrollment(){
            
            let ship_local={
                name:this.name_ship,
                n_omi:this.omi,
                flag:this.flag,
                call_sign:this.call_sign,
                material_casco:this.material_head,
                tipo_navegacion:this.type_navigate,
                tipo_nave:this.type_ship,
                tipo_propulsion:parseInt(this.d_type_propulsion.id),
                trb:parseFloat(this.trb),
                trn:parseFloat(this.trn),
                eslora:parseFloat(this.eslora),
                manga:parseFloat(this.manga),
                puntal:parseFloat(this.puntal),
                calado_min:parseFloat(this.calado),
                calado_max:this.calado_max,
                anio_contruction:parseInt(this.year_construction),
                lugar_construction:this.site_construction,
                costo_construction:this.cost_construction ? parseFloat(this.cost_construction):0,
                destino_servicio:this.type_service.id,
                importe:this.c_cost_enrollment,
                ufv:this.c_ufv,
                actividad_principal:this.actividad_principal,
                actividad_secundaria:this.actividad_secundaria,
                tipo_casco:this.tipo_casco
            }

            let motor={
                existe:this.engine.exists,
                marca:this.engine.trademark,
                modelo:this.engine.model,
                rpm:this.engine.rpm,
                serie:this.engine.serie,
                combustible:parseInt(this.engine.gasoline),
                autonomia:this.engine.autonomia,
                velocidad_maxima:parseFloat(this.engine.velocity_max),
                n_cilindros:this.engine.n_cilindros,
                t_cola:this.engine.tipo_cola,
                t_mezcla:this.engine.t_mezcla,
                cap_tanque:this.engine.cap_tanque,
                industria:this.engine.industria,
                qth_motor:this.engine.qth_motor,
                operabilidad_motor:this.engine.operabilidad_motor
            }

            let propietario={
                id_comandante:this.owner.id,
                complete:this.owner.complete,
                grade:this.owner.grade
            }

            let complementarios={
                empresa_construccion:this.empresa_construccion,
                lugar_botadura:this.lugar_botadura,
                operabilidad:this.operabilidad,
                qth_embarcacion:this.qth_embarcacion,
                velocidad_crucero:this.vel_crucero,
                velocidad_maxima:this.vel_maxima,
                combustible_hora:this.comb_hora,
                autonomia:this.autonomia,
                francobordo_p_carga:this.fb_p_carga,
                francobordo_s_carga:this.fb_s_carga,
                cantidad_radios:this.cant_radios,
                cantidad_baterias:this.cant_baterias,
                frecuencias:this.frecuencias,
                marca_radio:this.marca_radio,
                modelo_radio:this.modelo_radio,
                ametralladoras:this.ametralladoras,
                fusiles:this.fusiles,
                superestructura:this.superesctructura,
                dispositivo_averias:this.dispositivo_averias,
                salvataje:this.salvataje,
                tiempo_vida_nave:this.tiempo_vida_nave
            }

            let complementario_dos={
                bomba_achique:this.b_achique,
                bomba_agua:this.b_agua,
                tanque_flotacion:this.tanque_flotacion,
                ecosonda:this.ecosonda,
                gps:this.gps,
                rosa_nautica:this.rosa_nautica,
                luces_navegacion:this.luces_navegacion,
                giro_compas:this.giro_compas,
                pluma_pescante:this.pluma_pescante,
                base_remolque:this.base_remolque,
                radar:this.radar,
                chaleco_salvavidas:this.chaleco_salvavidas,
                guindolas:this.guindolas,
                botiquin_paux:this.botiquin_paux,
                extintor:this.extintor,
                cabos:this.cabos
            }

            let param={
                    boat:JSON.stringify(ship_local),
                    motor:JSON.stringify(motor),
                    owner_ship:JSON.stringify(propietario),
                    complementario:JSON.stringify(complementarios),
                    complementario_dos:JSON.stringify(complementario_dos)
            }
            //# FIXME: verificar el rechazo si es que la serie del motor se encuentra registrado y se intenta registrar el mismo, se debe rechazar e indicar que la serie del motor ya esta registrada 
            
            // console.log(ship_local);
            let message = {
                title: `Solicitud de Matriculacion de Nave`,
                body: `¿Desea registrar la solicitud para la Nave o Artefacto Naval, <b>${ship_local.name.toUpperCase()}</b> ?`
            };

            let npr=new Promise((resolve, reject)=>{
                this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });

            npr.then((msg) =>{
                if(msg){
                    this.mProgressModal();
                    // axios.post(`insertRequestEnrollment`,
                    axios.post(`insertRequestEnrollment?api_token=${Vue.auth.getToken()}`,
                                qs.stringify(param))
                    .then(res=>{                        
                        setTimeout(()=>{
                            this.mCloseProgressModal();
                            this.modal_rep_content=res.data[0].respuesta;
                            this.id_reporte=res.data[1].id_rep;
                            if(this.id_reporte !== 0){
                                toastr.success('Exito en el registro de la solicitud', 'Exito');
                                this.mModalReportShow();
                                this.mResetSelectOwner();
                                this.mResetForm();
                            }else{
                                toastr.error('Ha ocurrido un error', 'Error');
                                this.mModalReportShow();
                            }
                            
                        }, 2000);
                        
                    }).catch(error => {
                        setTimeout(()=>{
                            this.mCloseProgressModal();
                            toastr.error('Verifique la serie o la documento del propietario','Error');
                        }, 3000);
                        console.log(error)
                    })
                    }else{
                        console.log('se ha rechazado la baja del personal')
                    }
                })
            

        },
        mValidateSend(){
            let aux_validate=true;

            if(!this.name_ship && aux_validate){
                toastr.error('Verifique el nombre de la nave','Nombre');
                aux_validate=!aux_validate;
            }
            if(!this.material_head && aux_validate){
                toastr.error('Verifique el material del casco de la nave','Material Casco');
                aux_validate=!aux_validate;
            }
            if(!this.type_navigate && aux_validate){
                toastr.error('Verifique el tipo de Navegacion','Tipo Navegacion');
                aux_validate=!aux_validate;
            }
            if(!this.type_ship && aux_validate){
                toastr.error('Verifique el tipo de Nave','Tipo Nave');
                aux_validate=!aux_validate;
            }
            if(!this.d_type_propulsion.id && aux_validate){
                toastr.error('Verifique el tipo de Propulsion','Propulsion');
                aux_validate=!aux_validate;
            }
            if(!this.trb && aux_validate){
                toastr.error('Verifique el TRB','TRB');
                aux_validate=!aux_validate;
            }
            if( parseFloat(this.trb) <= parseFloat(this.trn) ){
                toastr.error('El TRN debe ser menor al TRB','TRB');
                aux_validate=!aux_validate;
            }
            this.actividad_principal=this.actividad_principal.trim();
            if(this.actividad_principal.length===0){
                toastr.error('Verifique el tipo de servicio de la Nave','Tipo Servicio');
                aux_validate=!aux_validate;
            }
            if(!this.owner.id === 0){
                toastr.error('Indique el Nombre del Comandante de la Embarcación','Comadante UUSS');
                aux_validate=!aux_validate;
            }
            if(aux_validate){
                this.mSendEnrollment();
            }
            
        },
        mResetForm(){
            this.name_ship=null;
            this.omi=null;
            this.flag='BOLIVIA';
            this.call_sign=null;
            this.material_head=null;
            this.type_ship=null;
            this.material_heads=[];
            this.type_ships=[];
            this.eslora=null;
            this.manga=null;
            this.puntal=null;
            this.calado=null;
            this.year_construction=null;
            this.site_construction=null;
            this.cost_construction=null;
            this.d_type_activity_ship=null;
            this.d_types_activity_ship=null;
            this.trn=null;
            this.trb=null;
        },
        mChangeOwnerIdentification(){
            
            switch(this.owner.type_identification){
                case 17:
                // cedula identidad
                    this.d_disabled_partner=true;
                break;

                case 18:
                // nit
                    this.d_disabled_partner=false;
                break;
            }
        },
        callUfv(){
            // axios.get('ufv?api_token='+Vue.auth.getToken())
            // axios.get(`ufv`)
            axios.get(`ufv?api_token=${Vue.auth.getToken()}`)
            .then(res => {
                // console.log(res.data[0])
                // this.ufv=res.data[0].value;
                this.ufv_date=res.data[0].date;
                this.$store.dispatch('addUFV', res.data[0].value);
                // this.();
            })
        },
        fNext(){
            switch(true){
                case this.is_active_step_one:
                    this.is_active_step_one=false;
                    this.is_active_step_two=true;
                break;

                case this.is_active_step_two:
                    this.is_active_step_two=false;
                    this.is_active_step_tree=true;
                break;

                case this.is_active_step_tree:
                    this.is_active_step_tree=false;
                    this.is_active_step_fourth=true;
                break;

                case this.is_active_step_fourth:
                    this.is_active_step_fourth=false;
                    this.is_active_step_five=true;
                break;
                
                case this.is_active_step_five:
                    this.is_active_step_five=false;
                    this.is_active_step_six=true;
                break;
            }
        },
        fBack(){            
            switch(true){
                case this.is_active_step_two:
                    this.is_active_step_two=false;
                    this.is_active_step_one=true;
                break;

                case this.is_active_step_tree:
                    this.is_active_step_tree=false;
                    this.is_active_step_two=true;
                break;

                case this.is_active_step_fourth:
                    this.is_active_step_fourth=false;
                    this.is_active_step_tree=true;
                break;

                case this.is_active_step_five:
                    this.is_active_step_five=false;
                    this.is_active_step_fourth=true;
                break;

                case this.is_active_step_six:
                    this.is_active_step_six=false;
                    this.is_active_step_five=true;
                break;
            }
        }
    },
    computed:{
        c_ufv(){
            return this.$store.getters.getUFV;
        },
        c_type_propulsion:function(){
            return this.d_type_propulsion.factor;
        },
        c_trb:function(){
            return this.trb;
        },
        c_service:function(){
            return this.type_service.factor;
        },
        c_cost_enrollment(){
            // console.log(` valores ${this.c_ufv}, ${ this.c_type_propulsion }, ${ this.c_service }, ${ this.trb}, ${this.c_cal_cut}`)
            let cost_enrollment = 3*this.c_ufv*(5+this.c_type_propulsion*this.c_service*this.trb*this.c_cal_cut);
            // let cost_enrollment = 3*this.c_type_propulsion;
            
            let aux_number=cost_enrollment.toFixed(2);
            
            let number_enter=Math.trunc(aux_number);
            let number_decimal=Number((aux_number-number_enter).toFixed(2));

            

            if(number_decimal===0.50){
                cost_enrollment=aux_number;

            }else if(number_decimal>0.50){
                cost_enrollment=number_enter+1;
                
            }else{                
                cost_enrollment=number_enter;
            }

            return cost_enrollment;
        },
        c_cal_cut(){
            let fact_a=0.1; 
            let fact_b=2;
            let fact_c=1.8;
            let cut=fact_c/(1+fact_a*Math.pow(this.c_trb, (1/fact_b) ))/2.3;
            return cut;
        },
        cQuestionEngine(){
            return this.d_question_engine;
        }
    },
    watch:{
        query_owner(newOwner) {
            axios.get(`searchPerson/${newOwner}?api_token=${Vue.auth.getToken()}`)
                .then((res) => {
                    // console.log(res.data);                    
                    this.owners_enrollment = res.data
                    // this.users = res.data.items
                }).catch(error => {
                    console.log(error);
                })               
        }
    },
    components:{
        'modal-loading':modalLoading,
        'modal-report':modalReport
    }
}
</script>



// WEBPACK FOOTER //
// src/components/matriculacion/Matriculacion.vue